<template>
  <el-row>
    <el-col :sm="12" :md="12" :lg="8" :xl="8" v-for="i in 9" :key="i">
      <div class="p-8 mb-20">
        <div class="flex-container p-4">
          <el-skeleton-item variant="image" style="width:75px; height:75px" />
          <div style="width: 30%; margin-left: 16px;">
            <el-skeleton-item variant="h1" />
            <el-skeleton-item variant="button" />
          </div>
        </div>
        <div class="p-4">
          <div class="flex-container mt-4">
            <el-skeleton-item variant="text" style="width:30%" />
            <el-skeleton-item variant="text" class="ml-16" />
          </div>
          <div class="flex-container mt-4">
            <el-skeleton-item variant="text" style="width: 30%" />
            <el-skeleton-item variant="text" class="ml-16" />
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script setup>
</script>
